import { SupplierAndLogPartnerSuggetions, supplierAndPartnterfilter , getMPSuppliers } from "@/api/memberAPI"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const supplierAndLogPartnterSuggetion = createAsyncThunk("member/SupplierAndLogPartnerSuggetions", async (reqData) => {
    return await SupplierAndLogPartnerSuggetions(reqData);
});


// export const fetchsupplierAndPartnter = createAsyncThunk(
//   "member/fetchsupplierAndPartnter",
//   async ({ type, country, company, industry, product, search, searchBy, query }) => {
//     return await supplierAndPartnterfilter(type, country, company, industry, product, search, searchBy, query);
//   }
// );
export const fetchsupplierAndPartnter = createAsyncThunk(
    "member/fetchsupplierAndPartnter",
    async (params) => {
        return await supplierAndPartnterfilter(params);
    }
);

export const fetchMPSuppliers = createAsyncThunk(
    "member/fetchMPSuppliers",
    async (reqObj) => {
        return await getMPSuppliers(reqObj);
    }
)


const memberSlice = createSlice({
    name: "filter",
    initialState: {
        data: [],
        searchData: [],
        loading: false,
        error: null,
        mpSuppliers: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(supplierAndLogPartnterSuggetion.pending, (state) => { state.loading = true })
            .addCase(supplierAndLogPartnterSuggetion.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload
            })
            .addCase(supplierAndLogPartnterSuggetion.rejected, (state) => {
                state.loading = false;
                state.data = [];
                state.error = "Something Went Wrong!";
            })

            .addCase(fetchsupplierAndPartnter.pending, (state) => { state.loading = true })
            .addCase(fetchsupplierAndPartnter.fulfilled, (state, action) => {
                state.loading = false;
                state.searchData = action.payload
            })
            .addCase(fetchsupplierAndPartnter.rejected, (state) => {
                state.loading = false;
                state.searchData = [];
                state.error = "Something Went Wrong!";
            })

            .addCase(fetchMPSuppliers.pending, (state) => { state.loading = true })
            .addCase(fetchMPSuppliers.fulfilled, (state, action) => {
                state.loading = false;
                state.mpSuppliers = action.payload
            })
            .addCase(fetchMPSuppliers.rejected, (state) => {
                state.loading = false;
                state.mpSuppliers = [];
                state.error = "Something Went Wrong!";
            })


    }
});



export default memberSlice.reducer;